import { useContext } from 'react';
import { SplitContext, useTreatments } from '@splitsoftware/splitio-react';
import { Outlet } from 'react-router';

import {
    BRANDS as BB_SIGNUP_BRANDS,
    FEATURE_FLAG as BB_SIGNUP_FEATURE_FLAG,
} from 'constants/featureFlags/boysenberrySignup';
import useGlobalStore from 'hooks/useGlobalStore';

export default function AccountCreationLayout() {
    const { isMisfitsTheme } = useGlobalStore();
    const { isReady: splitIsReady } = useContext(SplitContext);
    const treatments = useTreatments([BB_SIGNUP_FEATURE_FLAG], {
        brand: isMisfitsTheme ? BB_SIGNUP_BRANDS.misfitsMarket : BB_SIGNUP_BRANDS.imperfectFoods,
    });
    const treatment = treatments[BB_SIGNUP_FEATURE_FLAG]?.treatment;

    return (
        <main className="mx-auto flex max-w-screen-md flex-col p-25">
            {splitIsReady && <Outlet context={{ treatment }} />}
        </main>
    );
}
